const CONFIG = {

    SUBMIT_URL: 'https://ps-04.baibol.ru/payment/', // куда улетает форма при сабмите
    RECAPTCHA_KEY: '6Le8sz8eAAAAAGEziKytkLmci-jczV-HfylDkeAc', // идентификатор, необходимый для работы рекапчи

    // платёжная форма Т-Банка
    PHONE_LENGTH: 16, // длина телефона
    MIN_CONTRACT_LENGTH: 6, // минимальная длина договора
    MAX_CONTRACT_LENGTH: 11, // максимальная длина договора
    MIN_AMOUNT: 50, // минимальная сумма платежа
    MAX_AMOUNT: 500000, // максимальная сумма платежа

    // полезные ссылки
    LINKS: {
        PAY_ROOLS_PDF: 'https://baibol.ru/Документы/Правила оплаты и безопасности платежей, конфиденциальность информации.pdf', // правила, с которыми ознакомлен
        VIDEO_INSTRUCTION: 'https://rutube.ru/video/private/3eb26783ba46aa6b25c4d48027dc8e22/?p=BtvLqoGPQDfJMr1aH9nMyQ', // Видеоинструкция по погашению займа
        MOBILE_APP: 'https://apps.rustore.ru/app/com.baibol', // Мобильное приложение Байбол Онлайн
        CHOOSE_LANG: { // инструкции по выбору языка
            RU: 'https://baibol.ru/upload/Comp 3_2.mp4',
            UZ: 'https://youtu.be/6NiVJIbYwPE',
            KG: 'https://youtu.be/fqDAeF7R--U',
            TJ: 'https://youtu.be/pC2nte3pjwI',
        },
        // ссылки на скачивание приложений
        APPS: {
            GOOGLE: 'https://play.google.com/store/apps/details?id=com.baibol',
            RUSTORE: 'https://www.rustore.ru/catalog/app/com.baibol',
            APK: 'https://baibol.ru/upload/app-release_web.apk'
        },
        SBERBANK: {
            OIB: 'https://www.sberbank.ru/ru/about/today/oib', // В отделениях и в банкоматах и терминалах
            INNER_APPS: 'https://www.sberbank.ru/ru/person/dist_services/inner_apps', // На сайте и в мобильном приложении
        },
        ELECSNET: {
            TERMINALS: 'https://elecsnet.ru/terminals/', // В терминалах “Элекснет”
            INSTRUCTION: 'https://www.youtube.com/watch?v=_yWhVYdarN8', // Видео инструкция
            SITE: 'https://1.elecsnet.ru', // сайт
        },
        KORONA: {
            REPAYMENT: 'https://koronapay.com/repayment/', // В платежных сервисах
        },
        BAIBOL: {
            MAIN: 'https://baibol.ru/', // Основной адрес
            ABOUT: 'https://baibol.ru/about/', // О компании
            DOCUMENTS: 'https://baibol.ru/about/documents/', // Документы компании
            JOB: 'https://baibol.ru/about/job-in-baibol/', // Вакансии Байбол
            OFFICES: 'https://baibol.ru/about/offices/', // Отделения
            LOANS: 'https://baibol.ru/loans/', // Получить заём
            BUY_HISTORY: 'https://baibol.ru/additional-services/buy-history/', // Проверить кредитную историю
            COMPLAINTS: 'https://baibol.ru/about/complaints/', // Оставить жалобу
            FEEDBACK: 'https://baibol.ru/about/feedback/', // Оставить отзыв
            NEWS: 'https://baibol.ru/news/', // Новости
            LITERACY: 'https://baibol.ru/additional-services/financial-literacy/', // Важно знать
            FAQ: 'https://baibol.ru/news/faq/', // Вопрос-ответ
            SEARCH_MAP: 'https://baibol.ru/search/map.php', // Карта сайта
            CONTACTS: 'https://baibol.ru/contacts/', // Контакты
            SEARCH: 'https://baibol.ru/search/', // поисковый урл
        },
        SBR: {
            MAIN: 'https://www.cbr.ru/', // Официальный сайт Банка России
            RECEPTION: 'https://www.cbr.ru/reception/', // Интернет-приемная Банка России
            REGISTRY: 'https://www.cbr.ru/microfinance/registry/', // Государственный реестр микрофинансовых организаций
        },
        NPMIR: 'https://npmir.ru/', // официальный сайт в информационно-телекоммуникационной сети "Интернет"
        OMBUDSMAN: 'https://finombudsman.ru/', // официального сайта финансового уполномоченного
        TELEGRAM_BOT: 'https://teleg.run/MKKBaibol_bot', // ссылка на телеграм-бота
    }
};

export default CONFIG;